/* Version: 3.5.137 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { safeRest } from '../../utils/functions.js';
import { CardSeparatorWrapper } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var CardSeparator = function CardSeparator(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var theme = useTheme();
  var safeProps = safeRest(rest);
  return /*#__PURE__*/jsx(CardSeparatorWrapper, _objectSpread({
    "data-testid": "separator",
    theme: theme
  }, safeProps));
};
process.env.NODE_ENV !== "production" ? CardSeparator.displayName = 'CardSeparator' : undefined;

export { CardSeparator as default };
